module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap7"
    }
  }, [_vm._v("Chapter 5")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WISTING FREE OF THE UBIQUITOUS")]), _vm._v(" hands, I stomped outside to the chill sunset, snatched up a handful of gravel, flung it at the great oaken doors.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“M’lord?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I whirled, wiping my eyes. Genard, the stableboy.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I been lookin’ for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Where’s Rustin?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“He said, tell Prince Rodrigo I can’t come today.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“He what?” My world reeled.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I hadda talk through the small window; the gate ’cross the road was closed. Isn’t it left open most of the time?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What else did he say?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Nothin’, m’lord. He had a guard give me a coi—well, he tol’ me be sure you got the message at once. ‘Sorry, I can’t come today.’ That’s all.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Hurl him into the seventh lake of fire!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The stableboy made a hex, for protection. “May I go now, m’lord? Griswold says I’m to—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Go.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Still, he hesitated. “Sire, please, don’ send me on your errands, down hill an’ all. I look after horses, and wheel dung carts to the fields. What’s between lords isn’t my ken.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I shook him. “You’ll do what a noble of this House commands! Begone!” He scurried off.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Uncle Mar would treat me as a child, and I couldn’t prevent it. Now, even a stableboy defied me. In as foul a temper as I could recall I climbed the ramparts, made sure no one was looking, ascended the high tower. “Elryc?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Behind the barrels, no one.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Where are you, brat of Caledon?” I peered out the door to the empty deck. “If you’ve run off to play, I’ll throw you off the cursed wall!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Here.” I whirled; saw nothing until the lid of a barrel moved. “Help me out.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What in blazes are you doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It was safer, in case they made you tell.” He rolled onto the floor, brushed himself clean as he stood. A glance at my empty hands. “Roddy, I haven’t had a bite since—” His eyes darted to the bench, to my empty hands. “You "), _c('i', [_vm._v("forgot?”")]), _vm._v(" His voice rose to a piercing squeak.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You gorged yourself, and didn’t even bring me an apple?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I couldn’t. Since I left I’ve been—” No use; a tear rolled down his cheek. “Oh, stop, Elryc, I’ll get you a meal.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He slumped on the bench, crestfallen. “How could you? Do I mean nothing?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“They took Pytor to Verein.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He gulped. “Uncle Mar’s castle?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I asked to ride to him, and was forbidden.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What will they do to him?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You’re to be sent also, as soon as they find you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Roddy, protect me.” He sidled close, sniffling, and rubbed his cheek softly on my shoulder. “I’m sorry I snarled about the food, I’m so afraid, I didn’t mean it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Before thought intervened, my arms snaked round, wrapped him tight. “Of course I will.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“They’ll kill me! I’ll be good, Roddy, I won’t ever make fun of—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Lord of Nature. What was I, that made even my own brother cower? “Stop!” I covered his mouth. “I won’t let them take you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We’ll have to hide.” He shivered. “The nights get cold; I’ll need blankets. Water, and ...” He looked apologetic. “Food.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I forced my brain to a canter. “We can’t keep you here; sooner or later they’ll search.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“If I show myself ...”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I know. Very well, stay here the night. I’ll be back with dinner and blankets. By morning I’ll know where to hide you. Rust can—” I bit off my words.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He buried his face in my arm. “How would they kill me, Roddy? A knife in the heart? Poison?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("My chest tightened. “Nobody will hurt you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Aggh, what if they cut my throat?” He retched, brought up naught but bile. When he turned back, his eyes were wild. “Mother warned us he might—Roddy, help me escape! Can we get our horses before—Do you think Pytor’s already dead? Will they throw me in a ditch?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I cuffed him, lightly, but enough so his words ceased to tumble. “Get hold of yourself! I’ll protect you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“But you’ll be angry with me; I can’t help saying what—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Elryc.” I managed to keep my voice steady. “Look at me. No, stop darting; look into my eyes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I waited until he complied.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Elryc of Caledon, Prince and brother. I shall protect thee from this evil. Nor Uncle Mar nor his minions shall harm thee while I draw breath. By the Power I would wield, by the crown I would don, I tell thee so in Truth!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Roddy.” He fell into my arms, trembling.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Later, making ready for bed, I considered what I’d done. In a moment of weakness, of foolish pity, I’d committed myself to the cause of my brother. Were I to betray him now, virgin or no, I could not ever take up my Power. And given my enemies and rivals for the crown, without the Still, I could not hold Caledon.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I felt sick.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I’d sworn utter loyalty to this boy, and hadn’t thought to demand he swear the same to me.")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("By the time I woke, the candle had burned below the ninth hour. I threw on my clothes, hopped to the door while fastening my boot, and loped down the stairs. In the kitchen, I managed to swipe half a loaf of bread soaked in bacon fat, and stuffed my eggs within. Shortly after, I climbed the tower.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“First light, hah!” Elryc rubbed his eyes. “For hours I’ve been worrying you were seized.” He snatched the rough cloth napkin in which I’d wrapped the food. “Eggs within bread? Are you crazed? And no water to wash with, or even to drink? Is dilute wine all you brought?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’ll do better next meal.” My tone was sour.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I hope so.” He tore off a huge chunk of bread, and silenced himself with it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("When he’d wolfed the last of his food we sat together behind the stacked barrels.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Roddy, I can’t stay here another night.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I know. It’s a nuisance bringing you—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’m cold and miserable, and they’ll search the walls sooner or later.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“That too. Right now I’m going to the keep, to see why Rust abandoned us. I’ll try to be back by midday, but you’ve apples left.” I left him grumbling, and went to the stables.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I could have had the boy summon the stablemaster, but chose instead to wander through the fly-infested stalls to the leather shop behind, where the old man was examining harness. I spoke with care, anxious not to provoke a new confrontation. “Griswold, I need a horse, if one is ready.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A glint of what might have been humor. “Well said, my lord. But where do you ride?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I bristled. “Is that concern of yours?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He spoke softly. “They say the gate’s closed to you unless you’ve gained Mar’s leave.” The old man’s face hid his thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("So, Uncle Mar had been serious about confining me to the castle grounds. Imps take me, I would not beg for leave like a mere child. I gave Griswold a curt nod. Then, thinking better, I leaned over the pommel, put my mouth close to his ear. “Thank you for the counsel.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I stalked off. Rustin would arrive this morning. Surely he must.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But he did not.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("As the day lengthened, my rage grew sharper. How dare Rustin abandon his liege lord? How was I to take Elryc his meals, clothes, a chamber pot? How could I move him to safety? Everyone knew his face, as they did mine.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Dinner hour neared, and I grew more frantic. My calves ached from walking about. Needing a place to think, I slipped into the stables.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Within, all was dust, as Genard wielded a tall straw broom with manic haste. “Hey, boy!” I coughed. “Set it down, before you choke us both!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Sorry, m’lord.” He grinned. “There’s always dirt and dust in a stable. You wouldn’t know, living up high.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Intimacy, from an urchin in torn soiled shirt and outgrown breeches? How dare he speak to me? His station was as far below mine as—as his filthy jerkin was to my cloak.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I turned on my heel, strode two paces, stopped as if I’d run into a wall. Would it work? Just possibly. “You. Garror.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Genard.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Whatever. Come close.” I looked him over. “How many shirts have you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I can’t help it, Griswold made me clean it new-moon-day last, and I haven’t had time since—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Have you another?” I made my voice stern.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Aye, but it’s small, and besides I save it for the Rites, when—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“And breeches?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He looked down, fingered a ragged hole. “The other pair’s worse than these. I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I opened my tiepurse, fished out half a dozen coppers. “I want the loan of your worse breeks, and the shirt you wear. Be quick, before I—be quick.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The unexpected treasure disappeared into his shirt. “Aye, sir.” In one lithe motion he stripped off his rank shirt, thrust it into my hand, dropped the broom. “It won’t take me long!” He vanished, half-bare.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He returned a moment later, redressed, bearing breeches I would have tossed out the window rather than don. I took them between two fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What do you need them for, sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I glowered. “For matters beyond you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“’Cause everyone’s short-tempered now, what with their search for Elryc. Master Griswold might ask why I wear my best shirt, and if he gives me the stick, five more coppers would keep me silent.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I fixed him with a steely eye. “Shall I turn you into a toad, after I’m crowned? I’ll have the Power then. No, I have a better idea. A dung beetle!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("His look was one of awe. “Can the Still do that?” No, of course not. But, searching my face, he found something that subdued him. “Forget it, m’lord.” He backed away. “Not a word. I won’t ...” He was at the door.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Stop.” Never had I sounded so imperious. “Finish your sweeping. Where’s Griswold? If I come back and find you not here, you’ll live henceforth as a beetle!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Moments later I was in the shoeing room, waiting politely for Griswold to finish his words with the smith. When I got him aside I said casually, “I told one of Llewelyn’s stableboys he might stay here for a while.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Griswold’s eyebrow raised, and I could see what he supposed. I flushed. Were I not constrained by need of the Still, no one would think me unmanly, and in need of the solace of boys.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Doggedly, I went on. “Your lad sleeps in the loft, I suppose? Would you let this other stay with him, and no need to mention him to the household?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Griswold’s tone was carefully flat. “Very well. I’ll put your, uh, friend to work, of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“As you wish. The thing is, Uncle—the Duke Margenthar—is rather put out with me of late, and—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I won’t go out of my way to call his attention.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Thanking him, I rounded up the stableboy, bade him follow me to the battlement, and wait at the foot of the winding stone steps. Before I left I took pains to discuss with him the short life and limited menu of a dung beetle.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Above, Elryc was aghast at the garb I tendered him. “Me? That?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It took some persuasion before I had his good garments off him, and the others on. He held his arms away from his sides, as if afraid of his own touch. He said only, “Laugh at me and you’ll rue it!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I doubt he knew the effort it took to keep a straight face. I ruffled his hair to make it unkempt, bent to the deck, rubbed my hand in dust, wiped it on his face. “Come along. No, you idiot, don’t walk like you own the place. Shamble. And stop limping!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The gravel hurts! I need my boots.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Boys of your station have no boots.” I led him down the stairs. The stableboy’s eyes widened. “Garron, this is, um, Rendall, from Llewelyn’s house. Griswold said he’s to sleep in the loft.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Him? But he’s—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Shall I feed you some horse droppings, to introduce you to a beetle’s life?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Urk.” He shook his head vehemently.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Rendall, go directly to the stable, stay inside. Garror here will find some dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Genard, m’lord!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I eyed the long open walk to the stable. “I’ll go ahead; you two follow, making fun of my walk and jabbing each other in the ribs. Carry on like the idiots you are.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“M’lord, I’m not—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Bottle it.” I strode off, trying to keep my pace slow enough so as not to attract undue notice.")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("When dark fell, I dropped with weary relief into my bed, but barely had off my shirt when a sharp knock rattled the door. A servant summoned me to my uncle. Furious, I struggled back into my jerkin.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Uncle Mar paced his spacious anteroom, in the flickering candlelight. “Roddy, a serious matter.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I hope so. I was just getting to sleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Where is your brother?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("My lip curled. “You should know. Crying his heart out, in your imp-cursed castle of Verein.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I speak of Elryc!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Ask Hester. It’s a struggle to rid myself of his company.” I held Uncle’s eyes. So far, I’d told no untruth. “Why should I bother myself where he plays?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“A night and day he’s been gone. Has someone taken him? My responsibility as regent—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You look after the crown. I’ll worry about my brother.” I could have bitten out my tongue, for the saying of it. I had no choice but to brazen it out. “If he’s gone, so much the better. Think ye that I want a rival so near at hand, that those who dislike my inheritance may think to alter it in his favor?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You had no such fears about Pytor, when you came charging into Council.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Pytor’s our pet, and not cunning. Elryc is too smart, and cold. If you find him dead, be not too sure that my hand didn’t grasp the blade!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Nonsense. You two have been close.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“While Mother lived.” I chose my words with care. “Hers was the power to Renounce.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Ah, a schemer.” His tone was sardonic. “And you call Elryc cold.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I shrugged. “Right now, I’m tired. I’d like to go to bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“In a moment. Answer me True, Prince Rodrigo. By the Power you would wield, do you know where Elryc is?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I’d left him in the stables. But crossing the courtyard, he and Genard had danced after me like fools at a festival, and seemed friends when I’d left. After working hours, the stableboy was free to go where he wished. Perhaps Elryc was with him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I looked Margenthar straight in the eye. “I do not know where Elryc my brother is. I tell you True.” I tried to breathe normally.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He seemed disappointed. “Very well, you may go.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What colossal gall; dismissing me so. Did he think I was some cringing menial?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We thank our gracious regent.” My tone was at its most formal. I tried an airy wave, but it didn’t quite come off. I’d have to practice.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Back in my chamber I peeled off my damp clothes, crawled gratefully into bed. I’d gotten away with it, as far as my uncle was concerned, but had I squandered the Still by prevarication? I closed my eyes, laid my palms flat against my stomach, pretending my body was the stillsilver of the Still. How would it respond, when came the time?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("If Elryc was in the stable, had I lied? What if he was with Garmond, on some boyish prank? Had I told True, in that case? On the other hand, was Elryc so stupid, as to risk all for a lark? If he were caught and forced to tell how he’d been hidden, I was undone.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Elryc’s danger, the problems of my coronation, could wait until morning. I thought briefly of Mother, wished I’d listened more closely to her warnings, and fell into sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("In the middle of the black night there came a hammering and caterwauling at my door such as I’d never heard. “Open, in the name of the Duke! At once, Rodrigo!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Trembling, I leaped out of bed, dashed to the window. Below, the courtyard flickered with soldiers bearing torches.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Open, or we’ll break in the door!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I scrambled into my breeches, snatched up my dagger, wishing Mother had let me store my sword in my room, instead of at the fencing master’s.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Now!” A terrific thud at the door.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I glanced under the bed, thought of hiding, realized it would not do. I unbarred, braced myself for attack.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Soldiers swept me aside. “Search the trunks! Pull off the mattress, look under.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I gaped.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Behind the curtains!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“This is my personal chamber! By what right—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“By order of the regent.” Stire, the Duke’s baron. “Where’s Elryc?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“At Council, you told me he’d be sent to Verein with Pytor.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You know well he’s not—Do you have him?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("With dismay, I watched clothes, knickknacks and playthings strewn about. “How dare you! I’m Prince of Caledon!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("His face grew red. “Where in the demons’ lake is he?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I don’t know!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("We glared at each other, until he turned to a guard. “Any sign?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No, my lord.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“He’s sure to be somewhere in the castle. Help them search the servants’ quarters.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What about this mess?” My voice was too high-pitched.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I jumped, as he spat at my bare feet. “Why, clean it up, youngsire.” A slam, and they were gone.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("To my utter disgust, I sat amid the chaos of my belongings and sobbed. My rage finally spent, I threw water on my face, paced until just before dawn, when at last I was calm enough to rest.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The noise of the household woke me in early morn. Thoroughly short of sleep, I picked my way across the mess on the floor. My mood wasn’t improved when I slopped water from the washbasin onto my bare toes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Last night, while the furious wind of soldiers had torn through my chamber, I’d thought with some worry of Hester. Certainly they’d search the nursery, and her temper might well provoke the Duke’s men to violence.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Now, yawning over the breakfast table, I realized that though I’d pounded up and down the steps to the third floor of the castle while searching for Pytor night before last, I’d never gone back to tell Hester where I’d hidden Elryc. After a quick breakfast, I looked into the stables, found Genard, who’d made no secret that he’d recognized my brother. Now, when I threatened him anew, he shrugged. “Elryc—Rendall says you’re not like that, m’lord.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Who have you told?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The boy’s eyes had shifted. “No one, m’lord—don’t make that sign at me!” Quickly he threw up the hex of protection. “Master Griswold, was all. None else!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Griswold? Lord of Nature!” I rushed past the stalls, through the hayloft into the tack room, and found him there, knotting a harness.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Ah, Prince Rodrigo.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I slipped shut the door, as if a waist-high barrier would muffle our words. “You—Genard said he told—I mean, the new stableboy ...”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The new lad hasn’t worked out badly.” Griswold’s tone was placid. “Though he’s been rather hungry. Doesn’t Llewelyn feed his help?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I whispered, “Please. Don’t toy with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A look of surprise. “Why, my lord! Humility, at last?” He seemed pleased.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“He’s my ...” I couldn’t say it aloud. “You know who he is.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Me?” He seemed shocked. “Some lout from the town, I suppose. Kerwyn hired him; I’ve nothing to do with it. As long as he’s gentle with the horses.” He eyed me sternly, as if to make his point.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“They searched my room.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I heard the commotion. They came here twice, the day of my lady’s funeral.” Was the burial already two days past? I thought of Mother, below the earth, and shivered.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He waited. “Was there else?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I, uh, no ...” I thought to demonstrate my gratitude. “No, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("This time he positively smiled. “There’s hope for you yet, Lord Rodrigo. Just one thing ...”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Don’t loiter about the stable. You never did it before, and you’ll attract attention.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He was right. Disconsolate, I climbed wearily to the nursery.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The door was ajar; with trepidation I walked in, unbidden.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The old lady was at her table, her cheese and bread untouched. Her eyes seemed even more sunken than before. I lowered myself to the squat bench, ran my fingers along the splintered plank on which I’d been fed, spoon by spoon, by the crone who now sat dazed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Pytor would be done with his meal.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I jumped at the cracked voice.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She eyed the sun. “He’d be chafing to go out and play.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’m sure he’s well. Soon, we’ll ride to visit him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Oh, my Pytor.” She rocked, clutching her knees. “Lord of Nature be kind.” Her eyes were closed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I, uh, have news.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“From Verein?” Rheumy eyes found mine.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("My lips moved, but no sound emerged. “Of Elryc.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Her gaze fastened on my face, but she said not a word.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“He’s nearby.” I waited for a reply, but had only her fixed stare. I had to make sounds, to break the awful silence. “In the castle.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She stood. “Take me to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Are you mad? They’re searching. The moment they see you—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“They’ve been here, and gone.” Her fingers drummed the table. “Has he food?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes.” Whatever stableboys eat. I hadn’t thought to inquire.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She glared. “Who else knows?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I hemmed and hawed, not quite willing to trust her with my secrets. “Nobody—well, one man. And a boy, but he’s too frightened to—they’re to be trusted.” I yawned.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She spat. “No one’s to be trusted. Get Elryc clear of them, or kill them both!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Hester!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Don’t Hester me, you foolish whelp. If Margenthar takes him, it’s his life. Doubt you not!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I can’t go about murdering—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Then I will. Tell me the names.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It’s not come to that.” I eyed her with new wariness. I’d never realized how protected we boys had been, under her vigilance.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You’ve always been the stupid one. Now you’ll be the death of your brothers!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“As will you, unless you keep your voice low!” We glowered in mutual hostility. Stupid? Had I not saved Elryc’s life, daringly marched him across the courtyard to safety in full view of all?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Good day, Nurse.” My tone was sulky.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Keep me appraised, day by day.” She pointed a crooked finger. “Or I’ll seek you out.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I made my escape, wandered disconsolately through the castle. Perhaps Rustin would come today. If he didn’t appear by the noon meal, I’d walk down the lull and fetch him and Ebon both. I’d—no, I couldn’t get out the gate, now it was manned by Uncle Mar’s men.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What a nightmare life had become: Mother gone, Pytor taken, Elryc in hiding, and I myself restrained like a hawk on a strap.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I must be crowned. Only then could I turn events.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("No one had told me what date the Council had fixed for my coronation. I braced myself, put on an affable face, sought out Uncle Mar in his chambers.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He was gone to Verein, expected back the day after the morrow. No, he hadn’t left a message. I stalked out, barely able to keep from slamming doors in my wake.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He hadn’t even bothered to inform me.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I retreated to my room, bolted my door, cursed the fates that had placed me in his hands, and hating Rustin for his disinterest.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The Council had met, and scattered to the winds. Lord Warthen of the Sands, his bleak expression one of constant pain, had returned to his desert domain. Even to enlist his help, I had no desire to set forth on that long journey.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Grand-uncle Cumber had bid a curt good-bye, and returned to his hills. I knew Cumber disapproved of me, and probably wouldn’t help my cause. Worse, he’d tell Uncle Mar.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Still, if I could get through the gate I could ride to inquire of other Council members. Earl Groenfil’s castle was three days to the east, Soushire more southeast. I’d slept in the open before, without harm.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Abruptly I cursed myself for the dolt I was. No need to leave Elryc and journey so far to learn the plans for my coronation. I smoothed my hair, loped down the stairs to the Chamberlain’s offices. In the anteroom sat his supercilious clerk.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I debated whether to ask an audience, decided not to humiliate myself. Still, no need to go out of my way to alienate the Chamberlain. I crossed to Willem’s office, knocked politely, opened the door, and looked in.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A sigh. “Well, what now, Roddy? More coin?” He turned his paper on its face.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Uncle Mar left.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Of course. What of it?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What with the funeral and the Rites, I didn’t get a chance to sit at the meet.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No, it’s closed to outsiders.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I snarled, “You call me outsider?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Willem raised a placating palm. “A figure of speech.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What did they decide?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I can’t discuss it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Of course you may. You met in my name.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’m sworn by oath not to—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Sir Willem, this is me. Rodrigo.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It had the opposite effect from what I’d intended. His eyes drifted to the wardrobe, in which he kept the strap Mother had from time to time bade him apply. I flushed. “Those times are past.” Lord will that it be so. If Mar bade him beat me, I supposed I’d kill one of them, or myself, whichever were possible.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I changed the subject as casually as I could. “Why was Pytor taken?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“He’ll come to no harm; we have Margenthar’s unequivocal word on that. It was felt that the three of you made too tempting a target, should enemies consider a strike.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Rubbish.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Oh, not really. At Verein they’ve other lads Pytor’s age; he’ll be happy. And it’s not as if he’ll be gone forever.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Pray he’s not.” I was surprised at the menace in my tone.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Is there else?” Willem was curt.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What more did they—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I will "), _c('i', [_vm._v("not")]), _vm._v(" discuss Council matters!” He rang his bell.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“When will I be crowned?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The door opened.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Hallor, show the youngsire to the door.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What did Uncle Mar arrange? A month?” I ignored the clerk’s beckoning hand.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Roddy, that’s quite enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Two months? Three?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The clerk beckoned. “My lord, you must come with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('i', [_vm._v("“Not until I have answer!”")]), _vm._v(" My scream tore at my throat. “Tell me, Willem! How long did he say I must wait? A year?” I leaned over his desk. "), _c('i', [_vm._v("“TELL ME!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He gestured; the clerk scurried out. Willem said hesitantly, “Roddy, we never discussed it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("At my dumbfounded silence, he added, “Didn’t Mar tell you? The matter was put off ’til the next meet. Six months.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Speechless, I stared at nothing. After a while I realized my gaze had never left Willem.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He licked his lips. “Prince, I told you before, I must tread with care. I’m but a hireling, and the quarrels of lords ...”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You sound like a stableboy I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No matter.” I crossed to the door, paused. “If Mar hears you’ve told me, he’ll be annoyed.” I held his eyes. “So we won’t tell him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Willem studied my face, and, at last, nodded.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24c95819","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/12chap7.vue
// module id = 105
// module chunks = 0